// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ../views/modules/locations-block/assets/scss/locations-block.scss
// module id = 91
// module chunks = 27